import { render } from "./ResetPasswordPage.vue?vue&type=template&id=d5ebdaf4&scoped=true"
import script from "./ResetPasswordPage.vue?vue&type=script&lang=js"
export * from "./ResetPasswordPage.vue?vue&type=script&lang=js"

import "./ResetPasswordPage.vue?vue&type=style&index=0&id=d5ebdaf4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5ebdaf4"]])

export default __exports__